import React from 'react';
import { NewMealCategoryProvider } from 'contexts/new-meal-category.context';
import NewMealCategoryContent from './content';

const NewMealCategoryLayout = () => {
  return (
    <NewMealCategoryProvider>
      <NewMealCategoryContent />
    </NewMealCategoryProvider>
  );
};

export default NewMealCategoryLayout;
